import { Model } from '@hub-components';
import { MapStateDrilldown, MapStateDrilldownJSON } from './map-state-drilldown.model';
import { SnapshotSharingPermissions } from './snapshot-sharing-permissions.model';

export interface SnapshotJSON {
  id: string;
  item_id: string;
  item_name: string;
  type: string;
  public_uuid?: string;
  overview_note?: string;
  breakdown_note?: string;
  map_state_drilldowns?: MapStateDrilldownJSON[];

  sharing_permissions?: {
    overview?: boolean;
    breakdown?: boolean;
    comparisons?: boolean;
    breakdown_cost_based_metrics?: boolean;
    breakdown_viewability_metrics?: boolean;
  };
}

export class Snapshot extends Model {
  id: string;
  itemId: string;
  itemName: string;
  type: string;
  publicUuid?: string;
  overviewNote?: string;
  breakdownNote?: string;
  mapStateDrilldowns?: MapStateDrilldown[];
  sharingPermissions?: SnapshotSharingPermissions;

  constructor(obj: Partial<SnapshotJSON> = {}) {
    super(obj);

    if (obj.sharing_permissions) {
      this.sharingPermissions = new SnapshotSharingPermissions(obj.sharing_permissions);
    }

    if (obj.map_state_drilldowns) {
      this.mapStateDrilldowns = obj.map_state_drilldowns.map(drilldown => new MapStateDrilldown(drilldown));
    }
  }

  public asJson(): SnapshotJSON {
    return {
      id: this.id,
      item_id: this.itemId,
      item_name: this.itemName,
      type: this.type,
      public_uuid: this.publicUuid,
      overview_note: this.overviewNote,
      breakdown_note: this.breakdownNote,
      map_state_drilldowns: this.mapStateDrilldowns?.map(drilldown => drilldown.asJson()),
      sharing_permissions: this.sharingPermissions?.asJson(),
    };
  }
}
